<div (click)="setOrder()" class="d-flex" id="sort-button">
  <div>{{ label }}</div>
  <i [ngClass]="getIconClass()" class="fas ms-auto"></i>
</div>
